export default __webpack_public_path__ + "static/gallery-flauntit-2671af4488787164f020b146d81f83e5.png";